/* eslint-disable react/prop-types */
import { graphql } from "@apollo/client/react/hoc"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import gql from "graphql-tag"
import Overview from "./"

const OverviewWithData = compose(
  withProps(() => {
    const { facilityId } = useParams()
    return {
      facilityId,
    }
  }),
  graphql(
    gql`
      query FacilityName($facilityId: ID!) {
        facility(id: $facilityId) {
          id
          name
        }
      }
    `,
    {
      options: ({ facilityId }) => ({
        variables: {
          facilityId,
        },
      }),
      props: ({ data: { error, loading, facility } }) => {
        if (error) throw error
        if (loading) return { loading }

        return {
          facilityName: facility.name,
        }
      },
    }
  )
)(Overview)

export default OverviewWithData
